import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronDown, Loader2 } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui";
import type { FacilitatorStatus } from "@/hooks/useMarketplaceFacilitators";

interface MarkFacilitatorMenuProps {
  rows: FacilitatorStatus[];
  busy: boolean;
  disabled: boolean;
  triggerRef: React.Ref<HTMLButtonElement>;
  onMark: (marketplaceCode: string) => void;
}

export const MarkFacilitatorMenu: React.FC<MarkFacilitatorMenuProps> = ({
  rows,
  busy,
  disabled,
  triggerRef,
  onMark,
}) => (
  <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild>
      <Button
        ref={triggerRef}
        variant="outline"
        size="sm"
        disabled={disabled}
        aria-busy={busy}
        className="h-7 px-2.5 transition-[color,background-color,transform] duration-150 ease-out motion-safe:active:scale-[0.97]"
      >
        {busy && (
          <Loader2
            className="h-3.5 w-3.5 motion-safe:animate-spin"
            aria-hidden
          />
        )}
        Mark as facilitator
        <ChevronDown className="h-3.5 w-3.5 text-slate-400" aria-hidden />
      </Button>
    </DropdownMenu.Trigger>
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        align="start"
        sideOffset={4}
        className="z-50 min-w-[160px] rounded-md border border-slate-200 bg-white py-1 shadow-lg animate-fade-in dark:border-slate-800 dark:bg-slate-900"
      >
        {rows.map((row) => (
          <DropdownMenu.Item
            key={row.marketplaceCode}
            onSelect={() => onMark(row.marketplaceCode)}
            className="cursor-pointer px-3 py-2 text-sm text-slate-700 outline-none data-[highlighted]:bg-slate-50 dark:text-slate-300 dark:data-[highlighted]:bg-slate-800"
          >
            {row.marketplaceName}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>
);
